import { useQuery } from '@apollo/client/react';
import { NetworkStatus, OperationVariables } from '@apollo/client';
import { DashboardProject, GET_DASHBOARD_PROJECT_DETAILS } from 'domain/shared/newProject';

export const useDashboardProjectDetails = (projectId: string | number) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: DashboardProject }>(
    GET_DASHBOARD_PROJECT_DETAILS,
    {
      variables: { id: projectId.toString() },
      skip: !projectId,
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
  );

  const refetchProject = async (variables?: Partial<OperationVariables>) => {
    return refetch(variables).then(() => data?.baseProject);
  };

  return {
    project: data?.baseProject,
    loading,
    error,
    refetch: refetchProject,
    isDataReloading: !data || networkStatus !== NetworkStatus.ready,
  };
};
